import { render } from "./DynvibeAreaStacked.vue?vue&type=template&id=be8f8a8e&scoped=true"
import script from "./DynvibeAreaStacked.vue?vue&type=script&lang=js"
export * from "./DynvibeAreaStacked.vue?vue&type=script&lang=js"

import "./DynvibeAreaStacked.vue?vue&type=style&index=0&id=be8f8a8e&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be8f8a8e"]])

export default __exports__